export const splitCamelCase = (value: string): string =>
  value.replace(/([a-z])([A-Z])/g, '$1 $2');

export const splitDigitBoundaries = (value: string): string => value
  .replace(/(\d+)([a-zA-Z])/g, '$1 $2')
  .replace(/([a-zA-Z])(\d+)/g, '$1 $2');

const capitalizeFirst = (value: string): string =>
  value.replace(/^./, (char) => char.toUpperCase());

export const capitalizeWords = (value: string): string =>
  value.replace(/\b\w/g, (char) => char.toUpperCase());

export const camelToNormal = (value: string): string =>
  (value ? capitalizeFirst(splitDigitBoundaries(splitCamelCase(value))) : value);